var render = function render(){var _vm=this,_c=_vm._self._c;return _c('carousel',{attrs:{"auto":0,"watch-items":_vm.post,"dots":true,"next-html":_vm.next,"prev-html":_vm.prev}},_vm._l((_vm.post),function(item,index){return _c('carousel-item',{key:index},[_c('item-media',{attrs:{"post":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }